
<script lang="ts">
    export let text: string = 'Click me';
    export let disabled: boolean = false;
    export let showIcon: boolean = false;
    export let _class: string = '';
    export let saved: boolean = true;
</script>

<button class="btn-main dont-break {_class}" class:showIcon={showIcon} on:click disabled={disabled} >
    {text}
    {#if !saved}
        *
    {/if}
</button>

<style>
    .btn-main {
        /*background-color: #1c5dc7; !* var(--analytics-green); *!*/
        /*color: white;*/
        padding: 0 12px;
        border: none;
        cursor: pointer;
        min-width: 90px;
        height: 28px;
        border-radius: 14px;
        position: relative;
        font-size: 12px;
        font-weight: 600;
    }
    .showIcon {
        padding-right: 40px;
    }
    .btn-main[disabled] {
        background-color: var(--automapa-grey-dark);
        cursor: not-allowed;
    }

    .unlock {
        /*font-size: inherit;*/
        /*background-color: #e0e0e0 !important;*/
        background-color: #1d5fc9 !important;
        border: 1px solid #1d5fc9;
        color: #fff !important;
        text-transform: uppercase;
    }
    .lock {
        /*font-size: inherit;*/
        background-color: #000 !important;
        border: 1px solid #000;
        color: white !important;
        text-transform: uppercase;
    }
</style>